import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import SoccerCamps from "@/pages/SoccerCamps";
import CoachEducation from "@/pages/CoachEducation";
import { LegalHub, LegalDoc } from "@/pages/Legal";
import Sports from "@/pages/Sports";
import SportDetail from "@/pages/SportDetail";
import Universities from "@/pages/Universities";
import SuccessStories from "@/pages/SuccessStories";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n/I18nProvider";

// Guard component — redirects unsupported language prefixes to default
const LangGuard = ({ children }) => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const first = path.split("/").filter(Boolean)[0];
  // /admin is a top-level, language-agnostic route
  if (first === "admin") return children;
  if (first && !SUPPORTED_LANGS.includes(first)) {
    return <Navigate to={`/${DEFAULT_LANG}${path}`} replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/admin" element={<Admin />} />
          <Route path=":lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Navigate to="../about" replace />} />
            <Route path="soccer-camps" element={<SoccerCamps />} />
            <Route path="coach-education" element={<CoachEducation />} />
            <Route path="partners" element={<Partners />} />
            <Route path="legal" element={<LegalHub />} />
            <Route path="legal/:slug" element={<LegalDoc />} />
            <Route path="sports" element={<Sports />} />
            <Route path="sports/:slug" element={<SportDetail />} />
            <Route path="universities" element={<Universities />} />
            <Route path="success-stories" element={<SuccessStories />} />
            <Route path="resources" element={<Resources />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="" replace />} />
          </Route>
          <Route
            path="*"
            element={
              <LangGuard>
                <Navigate to={`/${DEFAULT_LANG}`} replace />
              </LangGuard>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
